import Cookies from 'js-cookie';

import { readLandingPageCookie } from 'src/lib/cookies';
import { getDomainUserId } from 'src/lib/snowplow';

interface FacebookCookieValues {
  facebook_cookie_click_id_fbc: unknown;
  facebook_cookie_browser_id_fbp: unknown;
}

interface SnowplowCookieValues {
  snowplow_cookie_domain_user_id?: string;
}

interface TrackingPayload extends Record<string, unknown> {
  facebook_cookie_click_id_fbc: unknown;
  facebook_cookie_browser_id_fbp: unknown;
  snowplow_cookie_domain_user_id?: string;
}

const FACEBOOK_FBC_COOKIE = '_fbc';
const FACEBOOK_FBP_COOKIE = '_fbp';

export const getTrackingPayload = (): TrackingPayload => {
  const landingCookieValue = readLandingPageCookie();

  const facebookCookieValues: FacebookCookieValues = {
    facebook_cookie_click_id_fbc: Cookies.getJSON(FACEBOOK_FBC_COOKIE),
    facebook_cookie_browser_id_fbp: Cookies.getJSON(FACEBOOK_FBP_COOKIE),
  };

  const snowplowCookieValues: SnowplowCookieValues = {
    snowplow_cookie_domain_user_id: getDomainUserId(),
  };

  return {
    ...landingCookieValue,
    ...facebookCookieValues,
    ...snowplowCookieValues,
  };
};
